module.exports = __webpack_public_path__ + "static/icon.71a0472c.png";